import { create } from 'zustand'
import { VIRTUAL_COLLECTIONS } from '@/types/collection.types'

interface CollectionsStore {
  activeCollectionId: string
  isSidebarOpen: boolean
  selectedPromptIds: Set<string>
  viewMode: 'grid' | 'list'

  setActiveCollection: (id: string) => void
  setSidebarOpen: (open: boolean) => void
  togglePromptSelection: (id: string) => void
  selectPrompts: (ids: string[]) => void
  clearSelection: () => void
  setViewMode: (mode: 'grid' | 'list') => void
}

export const useCollectionsStore = create<CollectionsStore>((set) => ({
  activeCollectionId: VIRTUAL_COLLECTIONS.ALL,
  isSidebarOpen: true,
  selectedPromptIds: new Set(),
  viewMode: 'grid',

  setActiveCollection: (id) => set({ activeCollectionId: id }),
  setSidebarOpen: (open) => set({ isSidebarOpen: open }),
  togglePromptSelection: (id) =>
    set((state) => {
      const next = new Set(state.selectedPromptIds)
      if (next.has(id)) {
        next.delete(id)
      } else {
        next.add(id)
      }
      return { selectedPromptIds: next }
    }),
  selectPrompts: (ids) => set({ selectedPromptIds: new Set(ids) }),
  clearSelection: () => set({ selectedPromptIds: new Set() }),
  setViewMode: (mode) => set({ viewMode: mode }),
}))
